import React, { useState, useEffect, useCallback, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { getDefaultDashboardPath } from "../../utils/userRole";
import splashLogo from "../../assests/text transparent.png";
import styles from "./splashScreen.module.scss";

export default function SplashScreen() {
  const navigate = useNavigate();
  const location = useLocation();
  const loginUser = useSelector((state) => state.auth?.loginUser);
  const [isExiting, setIsExiting] = useState(false);
  const isNavigatingRef = useRef(false);

  const destination =
    location.state?.destination ||
    getDefaultDashboardPath(loginUser) ||
    "/dashboard";

  const handleContinue = useCallback(() => {
    if (isNavigatingRef.current) return;
    isNavigatingRef.current = true;
    setIsExiting(true);

    setTimeout(() => {
      navigate(destination, { replace: true });
    }, 600);
  }, [navigate, destination]);

  useEffect(() => {
    // 20-second automatic timer to transition to dashboard
    const timer = setTimeout(() => {
      handleContinue();
    }, 20000);

    // Also support keyboard enter/space/escape
    const handleKeyDown = (e) => {
      if (e.key === "Enter" || e.key === " " || e.key === "Escape") {
        handleContinue();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      clearTimeout(timer);
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [handleContinue]);

  return (
    <div
      className={`${styles.splashPage} ${isExiting ? styles.pageExiting : ""}`}
      onClick={handleContinue}
      role="button"
      tabIndex={0}
    >
      <div
        className={`${styles.ambientGlow} ${isExiting ? styles.glowExiting : ""}`}
      />
      <div
        className={`${styles.ambientRing} ${isExiting ? styles.ringExiting : ""}`}
      />

      <div className={styles.logoContainer}>
        <img
          src={splashLogo}
          alt="Kriha Garment OS"
          className={`${styles.logoImage} ${isExiting ? styles.logoExiting : ""}`}
        />
      </div>

      <div
        className={`${styles.bottomContainer} ${isExiting ? styles.bottomExiting : ""}`}
      >
        <div className={styles.hintText}>
          <span>Click anywhere to continue</span>
          <span>&rarr;</span>
        </div>
        <div className={styles.progressBarContainer}>
          <div className={styles.progressBar} />
        </div>
      </div>
    </div>
  );
}